import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { fabric } from 'fabric';
import { FabricJSCanvas, useFabricJSEditor } from 'fabricjs-react';
import { useEffect, useRef, useState, useCallback } from 'react';
import SimpleBar from 'simplebar-react';
import BtnGradient from 'src/components/common/button/BtnGradient';
// import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import PatientInfo from 'src/components/common/PatientInfo';
// import SpeechToText from 'src/components/common/SpeechToText';
import { getAPI, postFormDataAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import { COLOR_INDEX, TOOL_INDEX } from './Const';
import DialogCamera from './DialogCamera';
import ConfirmDialog from 'src/components/common/modal/ConfirmDialog';
import pako from 'pako';
import axios from 'axios';

const ZOOM_RATIO = 0.1;

const TOOLBAR_STYLE = {
  WIDTH: '40px',
  HEIGHT: '520px',
  COLUMN: 'column',
  ROW: 'row',
};

const TAB_RIGHT = {
  NONE: 0,
  INFORMATION: 1,
  AVATAR: 2,
  HISTORY: 3,
};

const ErasedGroup = fabric.util.createClass(fabric.Group, {
  original: null,
  erasedPath: null,
  initialize: function (
    original: any,
    erasedPath: any,
    options: any,
    isAlreadyGrouped: any
  ) {
    this.original = original;
    this.erasedPath = erasedPath;
    this.callSuper(
      'initialize',
      [this.original, this.erasedPath],
      options,
      isAlreadyGrouped
    );
  },

  _calcBounds: function (onlyWidthHeight: any) {
    const aX = [],
      aY = [],
      props = ['tr', 'br', 'bl', 'tl'],
      jLen = props.length,
      ignoreZoom = true;

    let o = this.original;
    o.setCoords(ignoreZoom);
    for (let j = 0; j < jLen; j++) {
      const prop = props[j];
      aX.push(o.oCoords[prop].x);
      aY.push(o.oCoords[prop].y);
    }

    this._getBounds(aX, aY, onlyWidthHeight);
  },
});

/*
 * Note1: Might not work with versions other than 3.1.0
 *
 * Made it so that the path will be 'merged' with other objects
 *  into a customized group and has a 'destination-out' composition
 */
const EraserBrush = fabric.util.createClass(fabric.PencilBrush, {
  /**
   * On mouseup after drawing the path on contextTop canvas
   * we use the points captured to create an new fabric path object
   * and add it to the fabric canvas.
   */
  _finalizeAndAddPath: function () {
    var ctx = this.canvas.contextTop;
    ctx.closePath();
    if (this.decimate) {
      this._points = this.decimatePoints(this._points, this.decimate);
    }
    var pathData = this.convertPointsToSVGPath(this._points).join('');
    if (pathData === 'M 0 0 Q 0 0 0 0 L 0 0') {
      // do not create 0 width/height paths, as they are
      // rendered inconsistently across browsers
      // Firefox 4, for example, renders a dot,
      // whereas Chrome 10 renders nothing
      this.canvas.requestRenderAll();
      return;
    }

    // use globalCompositeOperation to 'fake' eraser
    var path = this.createPath(pathData);
    path.globalCompositeOperation = 'destination-out';
    path.selectable = false;
    path.evented = false;
    path.absolutePositioned = true;

    // grab all the objects that intersects with the path
    const objects = this.canvas.getObjects().filter((obj: any) => {
      // if (obj instanceof fabric.Textbox) return false;
      // if (obj instanceof fabric.IText) return false;
      if (!obj.intersectsWithObject(path)) return false;
      return true;
    });

    if (objects.length > 0) {
      // merge those objects into a group
      const mergedGroup = new fabric.Group(objects);
      const newPath = new ErasedGroup(mergedGroup, path);

      const left = newPath.left;
      const top = newPath.top;

      // convert it into a dataURL, then back to a fabric image
      const newData = newPath.toDataURL({
        withoutTransform: true,
      });
      fabric.Image.fromURL(newData, (fabricImage) => {
        fabricImage.set({
          left: left,
          top: top,
        });

        // remove the old objects then add the new image
        this.canvas.remove(...objects);
        this.canvas.add(fabricImage);
      }, { crossOrigin: 'anonymous' });
    }

    this.canvas.clearContext(this.canvas.contextTop);
    this.canvas.renderAll();
    this._resetShadow();
  },
});

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const DialogDrawSlide = (props: any) => {
  const { editor, onReady } = useFabricJSEditor();
  const [color, setColor] = useState('#434154');
  const [tabRightActive, setTabRightActive] = useState(TAB_RIGHT.INFORMATION);
  const [showRightBar, setShowRightBar] = useState(true);
  const [activeColor, setActiveColor] = useState(new Array(3).fill(false));
  const [activeTool, setActiveTool] = useState(new Array(4).fill(false));
  const token = getToken();
  const [openDialogCamera, setOpenDialogCamera] = useState(false);
  const [historyList, setHistoryList] = useState<any>([]);
  const [imageList, setImageList] = useState<any>([]);
  const [toolbarStyle, setToolbarStyle] = useState<any>({
    width: TOOLBAR_STYLE.WIDTH,
    height: TOOLBAR_STYLE.HEIGHT,
    direction: TOOLBAR_STYLE.COLUMN,
  });
  const [showToolbarSpeechToText, setShowToolbarSpeechToText] =
    useState<boolean>(false);
  const [activeObjectAddText, setActiveObjectAddText] = useState<
    any | undefined
  >(undefined);
  const simpleBarRef = useRef<any>(null);
  const topScrollRef = useRef(0);  const [kartedate, setKartedate] = useState('');
  const [openConfirmCancel, setOpenConfirmCancel] = useState(false);
  const [historyState, setHistoryState] = useState({
    history: [] as string[],
    step: -1
  });
  const isProcessingHistoryRef = useRef(false);

  useEffect(() => {
    if (props.karteEdit) {
      setKartedate(props.karteEdit.kartedate);
    }
  }, [props.karteEdit]);

  useEffect(() => {
    if (!editor || !fabric) {
      return;
    }

    if (props.isKarteEdit) {
      editor.canvas.loadFromJSON(props.karteEdit.json, function () {
        editor.canvas.backgroundColor = '#FFFFFF';
        editor.canvas.renderAll();
      });
    } else {
      if (props.templateDetail || props.templateActive) {
        fabric.Image.fromURL(
          props.templateDetail.file || props.templateActive.thumbnail,
          (image) => {
            editor.canvas.setBackgroundImage(
              image,
              editor.canvas.renderAll.bind(editor.canvas)
            );
          }, { crossOrigin: 'anonymous' }
        );
      }
    }

    handleActiveColor(COLOR_INDEX.BLACK);
    handleActiveTool(TOOL_INDEX.EDIT);

    // eslint-disable-next-line
  }, [editor]);

  useEffect(() => {
    if (!editor || !fabric) {
      return;
    }
    editor.canvas.isDrawingMode = true;
    editor.canvas.freeDrawingBrush.color = color;
    editor.setStrokeColor(color);
    editor.canvas.freeDrawingBrush.width = 2;
  }, [color, editor]);

  useEffect(() => {
    if (props.patient) {
      try {
        getAPI(
          `/patient/get-gadget?patientid=${props.patient?.id}&type=image&token=${token}`
        ).then((res) => {
          if (res.code === 200) {
            const data = res.data.images.filter(
              (image: any) => image.deleted === 0
            );
            setImageList(data);
          }
        });
      } catch (error) {
        console.log(error);
      }

      try {
        getAPI(
          `/patient/get-surgery-gadget?patientid=${props.patient?.id}&type=surgery&caseid=0&token=${token}`
        ).then((res) => {
          if (res.code === 200) {
            const group = res.data.surgeries.reduce((result: any, row: any) => {
              if (!result.hasOwnProperty(row.quotedate)) {
                result[row.quotedate] = [];
              }
              result[row.quotedate].push(row);
              return result;
            }, []);
            setHistoryList(group);
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
    // eslint-disable-next-line
  }, [props.patient]);

  const onToggleDraw = () => {
    if (!editor) {
      return;
    }
    editor.canvas.freeDrawingBrush.width = 2;
    handleActiveTool(TOOL_INDEX.EDIT);
    editor.canvas.isDrawingMode = true;

    resetBrushToCurrentColor();
  };

  const resetBrushToCurrentColor = () => {
    if (!editor) return;
    
    const newBrush = new fabric.PencilBrush(editor.canvas);
    newBrush.color = color;
    newBrush.width = 2;
    editor.canvas.freeDrawingBrush = newBrush;
    editor.setStrokeColor(color);
  };

  const onAddText = () => {
    if (!editor) {
      return;
    }
    if (document) {
      const elementDialog = document
        .getElementById('dialog-draw')
        ?.getElementsByClassName('MuiDialog-container');

      if (elementDialog && elementDialog?.length > 0) {
        for (let i = 0; i < elementDialog?.length; i++) {
          elementDialog[i].removeAttribute('tabindex');
        }
      }
    }
    editor.canvas.isDrawingMode = false;
    handleActiveTool(TOOL_INDEX.TEXT);

    editor.canvas.on('mouse:down', function (opt) {
      const pointer = editor?.canvas.getPointer(opt.e);
      const text = new fabric.IText('', {
        fill: color,
        fontSize: 20,
        top: pointer.y,
        left: pointer.x,
        width: 100,
        textAlign: 'left',
        selectable: true,
      });
      editor?.canvas.add(text);
      editor.canvas.setActiveObject(text);
      text.enterEditing();
      text.hiddenTextarea?.focus();
      editor.canvas.off('mouse:down');
      handleActiveTool(TOOL_INDEX.SELECT);
    });
  };

  const onEraser = () => {
    if (!editor) {
      return;
    }
    handleActiveTool(TOOL_INDEX.ERASE);
    const eraserBrush = new EraserBrush(editor.canvas);
    eraserBrush.width = 10;
    eraserBrush.color = '#ffffff';
    editor.canvas.isDrawingMode = true;
    editor.canvas.freeDrawingBrush = eraserBrush;
  };

  const onSelectItem = useCallback(() => {
    if (!editor) {
      return;
    }
    handleActiveTool(TOOL_INDEX.SELECT);
    editor.canvas.isDrawingMode = false;
  }, [editor]);

  const saveCanvasState = useCallback(() => {
    if (!editor || isProcessingHistoryRef.current) return;

    const canvasState = JSON.stringify(editor.canvas.toJSON());
    
    setHistoryState(prev => {
      const newHistory = prev.history.slice(0, prev.step + 1);
      newHistory.push(canvasState);
      
      let newStep = prev.step + 1;
      
      // Giới hạn history tối đa 50 steps
      if (newHistory.length > 50) {
        newHistory.shift();
        newStep = Math.max(0, newStep - 1);
      }
      
      return {
        history: newHistory,
        step: newStep
      };
    });
  }, [editor]);

  useEffect(() => {
  if (!editor || !fabric) return;

  const initialState = JSON.stringify(editor.canvas.toJSON());
  setHistoryState({
    history: [initialState],
    step: 0
  });

  const eventsToSave = [
    'path:created',
    'object:added',
    'object:removed',
    'object:modified',
    'text:changed',
  ];

  let timeoutId: NodeJS.Timeout;
  const debouncedSave = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      saveCanvasState();
    }, 300);
  };

  const handleCanvasChange = () => {
    if (!isProcessingHistoryRef.current) {
      debouncedSave();
    }
  };

  eventsToSave.forEach(event => {
    editor.canvas.on(event, handleCanvasChange);
  });

  return () => {
    clearTimeout(timeoutId);
    eventsToSave.forEach(event => {
      editor.canvas.off(event, handleCanvasChange);
    });
  };
}, [editor, saveCanvasState]);

const onUndo = useCallback(() => {
  if (!editor || historyState.step <= 0) return;

  isProcessingHistoryRef.current = true;
  
  const previousState = historyState.history[historyState.step - 1];
  
  editor.canvas.loadFromJSON(previousState, () => {
    editor.canvas.renderAll();
    setHistoryState(prev => ({
      ...prev,
      step: prev.step - 1
    }));
    
    setTimeout(() => {
      isProcessingHistoryRef.current = false;
    }, 100);
  });
}, [editor, historyState]);

const onRedo = useCallback(() => {
  if (!editor || historyState.step >= historyState.history.length - 1) return;

  isProcessingHistoryRef.current = true;
  
  const nextState = historyState.history[historyState.step + 1];
  
    editor.canvas.loadFromJSON(nextState, () => {
      editor.canvas.renderAll();
      setHistoryState(prev => ({
        ...prev,
        step: prev.step + 1
      }));
      
      setTimeout(() => {
        isProcessingHistoryRef.current = false;
      }, 100);
    });
  }, [editor, historyState]);

  const onRemoveItem = useCallback(() => {
    if (!editor) return;
  
    const activeObject = editor.canvas.getActiveObject();
    
    if (!activeObject) {
      handleActiveTool(TOOL_INDEX.SELECT);
      editor.canvas.isDrawingMode = false;
      return;
    }

    if (activeObject.type === 'activeSelection') {
      const selection = activeObject as fabric.ActiveSelection;
      const objects = selection.getObjects().slice();
      
      editor.canvas.discardActiveObject();
      
      objects.forEach(obj => {
        editor.canvas.remove(obj);
      });
    } else {
      editor.canvas.remove(activeObject);
    }
    
    editor.canvas.renderAll();
  }, [editor]);

  const onZoomIn = () => {
    if (!editor) {
      return;
    }
    const zoom = editor.canvas.getZoom();
    editor.canvas.setZoom(zoom + ZOOM_RATIO);
  };

  const onZoomOut = () => {
    if (!editor) {
      return;
    }
    const zoom = editor.canvas.getZoom();
    if (zoom < ZOOM_RATIO * 2) return;
    editor.canvas.setZoom(zoom - ZOOM_RATIO);
  };

  const handleChangeColor = (changeColor: string, index: number) => {
    if (!editor) {
      return;
    }
    setColor(changeColor);
    handleActiveColor(index);
    editor.canvas.isDrawingMode = true;

    const newBrush = new fabric.PencilBrush(editor.canvas);
    newBrush.color = changeColor;
    newBrush.width = 2;

    editor.canvas.freeDrawingBrush = newBrush;
    editor.setStrokeColor(changeColor);
    
    handleActiveTool(TOOL_INDEX.EDIT);
  };

  const handleActiveColor = (index: number) => {
    const active = new Array(3).fill(false);
    active[index] = true;
    setActiveColor(active);
  };

  const handleActiveTool = (index: number) => {
    const active = new Array(4).fill(false);
    active[index] = true;
    setActiveTool(active);
  };

  const handleBtnTranscription = () => {
    const token = getToken();
    const infoPatientParams = `patient_no=${props.patient?.patientno}&patient_name=${props.patient?.fullname}&patient_id=${props.patient?.id}`;
    const url = `${process.env.REACT_APP_ARUKARU_AI_URL}?karte_token=${token}&${infoPatientParams}`;
    window.open(url, '_blank');
  };

  const cleanupFabricJson = (cleanedJson:any) => {
    if (cleanedJson.objects && Array.isArray(cleanedJson.objects)) {
      cleanedJson.objects.forEach((obj:any) => {
        if (obj.type === 'text' || obj.type === 'textbox') {
          if (obj.styles) {
            Object.keys(obj.styles).forEach(lineKey => {
              console.log(lineKey);
              if (Array.isArray(obj.styles[lineKey])) {
                obj.styles[lineKey] = obj.styles[lineKey].filter((style:any) => style !== undefined && style !== null);
              }
            });
          }
        }
      });
    }
    return cleanedJson;
  }

  const dataURLToBlobURL = (dataURL: string) => {
    const byteString = atob(dataURL.split(',')[1]); // decode base64
    const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0]; // get MIME type
  
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
  
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
  
    const blob = new Blob([ab], { type: mimeString });
  
    return URL.createObjectURL(blob);
  }

  const getBlobFiles = async (bloburls:any) => {
    let files = [];
    let extension:any = 'png';
    const config:any = { responseType: 'blob' };
    for (let i = 0; i < bloburls.length; i++) {
      const response = await axios.get(bloburls[i], config);
      if ('image/jpeg' === response.data.type) {
        extension = 'jpg';
      }
      files.push(new File([response.data], 'fabric_image_' + i + '.' + extension, {type: response.data.type}))
    }
    return files;
  };
  
  const handleBtnSave = async () => {
    if (!editor) {
      return;
    }
    const token = getToken();

    editor?.canvas.setZoom(1);

    let fabricObjectJson:any = editor?.canvas.toJSON();
    let images:any = [];
    let imageIndexs:any = [];

    for (let i = 0; i < fabricObjectJson.objects.length; i++) {
      if (fabricObjectJson['objects'][i].type === 'image' && fabricObjectJson['objects'][i].src.substr(0, 5) === 'data:') {
        images.push(dataURLToBlobURL(fabricObjectJson['objects'][i].src));
        imageIndexs.push(i);
      }
    }

    if (images.length > 0) {
      const files = await getBlobFiles(images);
      const uploadPromises = files.map((file, i) => {
        const formData = new FormData();
        const fileName = `fabric_image_${i}.png`;
        formData.append(`files[${i}]`, file, fileName);
        formData.append('patientid', props.patient?.id || '');
        formData.append('type', 'file');
        formData.append('caseid', '0');
    
        return postFormDataAPI(`/file/upload?token=${token}`, formData).then((res) => {
          if (res?.code === 200) {
            for (let j = 0; j < res.data.urls.length; j++) {
              const idx = imageIndexs[i];
              fabricObjectJson.objects[idx].src = res.data.urls[j];
              fabricObjectJson.objects[idx].fileid = res.data.ids[j];
            }
          }
        });
      });
  
      await Promise.all(uploadPromises);
      saveSchema(fabricObjectJson);
    } else {
      saveSchema(fabricObjectJson);
    }
  };

  const saveSchema = async (fabricObjectJson:any) => {
    if (!editor) {
      return;
    }
    const dataUrl = editor?.canvas.toDataURL({
      format: 'png',
      quality: 1.0,
    });



    let json:any = JSON.stringify(cleanupFabricJson(fabricObjectJson));
    json = pako.gzip(json);
    const base64CompressedData = btoa(String.fromCharCode.apply(null, json));

    const formData = new FormData();
    formData.append('patientid', props.patient?.id || '');
    formData.append('kartedate', kartedate);
    formData.append('imagestr', dataUrl || '');
    formData.append('json', base64CompressedData);
    
    try {
      postFormDataAPI(`/karte/save-shema?token=${token}`, formData).then((res) => {
        if (res?.code === 200) {
          console.log('upload success');
          props.handleReloadData();
          props.handleBtnReturn();
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  const handleBtnReturn = () => {
    if (!editor) {
      return;
    }
    const objects = editor.canvas.getObjects();
    if (objects.length > 0) {
      setOpenConfirmCancel(true);
    } else {
      props.handleBtnReturn();
    }
  };

  const handleConfirmCancel = () => {
    setOpenConfirmCancel(false);
    props.handleBtnReturn();
  };

  const handleCloseConfirm = () => {
    setOpenConfirmCancel(false);
  };

  const handleInformationClick = () => {
    setTabRightActive(TAB_RIGHT.INFORMATION);
    setShowRightBar(true);
  };

  const handleAvatarTabClick = () => {
    setTabRightActive(TAB_RIGHT.AVATAR);
    setShowRightBar(true);
  };

  const handleHistoryTabClick = () => {
    setTabRightActive(TAB_RIGHT.HISTORY);
    setShowRightBar(true);
  };

  const handleHideRightBar = () => {
    setShowRightBar(false);
    setTabRightActive(TAB_RIGHT.NONE);
  };

  const handleOpenCamera = () => {
    setOpenDialogCamera(true);
  };

  const handleCloseDialogCamera = () => {
    setOpenDialogCamera(false);
  };

  const handleCaptureImage = (imageCapture: string) => {
    if (!editor) {
      return;
    }
    setOpenDialogCamera(false);
    setTimeout(() => {
      onSelectItem();
      if (!editor) {
        return;
      }
      fabric.Image.fromURL(imageCapture, function (oImg) {
        oImg.set({ left: 0, top: 0 });
        editor.canvas.add(oImg);
      }, { crossOrigin: "anonymous" });
    }, 1000);
  };

  const handleChooseImage = async (event: any) => {
    if (!editor) {
      return;
    }

    if (event.target.files.length < 1) {
      return;
    }

    const file = event.target.files[0];
    if (!file) return false;

    const validExtensions = ['jpg', 'jpeg', 'png', 'svg+xml'];
    const fileExtension = file.type.split('/')[1];

    if (!validExtensions.includes(fileExtension)) {
      console.log('Invalid file type');
      return false;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      const base64 = (reader.result as string) || '';
      fabric.Image.fromURL(base64, function (oImg) {
        oImg.set({ left: 0, top: 0 });
        editor.canvas.add(oImg);
      }, { crossOrigin: "anonymous" });
      onSelectItem();
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  };

  const dragElement = (e: any) => {
    e.dataTransfer.setData('id', e.target.id);
  };

  const allowDrop = (e: any) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';
  };

  const dropElement = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (!editor) {
      return;
    }
    const data = e.dataTransfer.getData('id');
    if (data.startsWith('image-')) {
      const imag = document.getElementById(data) as HTMLImageElement;
      fabric.Image.fromURL(imag.src, function (oImg) {
        editor?.canvas.on('mouse:move', function (opt) {
          const pointer = editor?.canvas.getPointer(opt.e);
          oImg.set({
            left: pointer.x,
            top: pointer.y,
          });
          editor?.canvas.add(oImg);
          editor.canvas.off('mouse:move');
          onSelectItem();
        });
      }, { crossOrigin: "anonymous" });
    }
    if (data.startsWith('history-')) {
      if (document) {
        const elementDialog = document
          .getElementById('dialog-draw')
          ?.getElementsByClassName('MuiDialog-container');

        if (elementDialog && elementDialog?.length > 0) {
          for (let i = 0; i < elementDialog?.length; i++) {
            elementDialog[i].removeAttribute('tabindex');
          }
        }
      }
      const historyTime = document.getElementById(`${data}-time`);
      const historyContent = document.getElementsByClassName(`${data}-content`);

      let time = historyTime?.innerText || '';
      Array.from(historyContent).forEach((content: any, index: number) => {
        time += `\n> ${content.innerText}`;
      });
      editor?.canvas.on('mouse:move', function (opt) {
        const pointer = editor?.canvas.getPointer(opt.e);
        const text = new fabric.IText(time, {
          fill: color,
          fontSize: 20,
          top: pointer.y,
          left: pointer.x,
          selectable: true,
        });
        editor?.canvas.add(text);
        editor.canvas.setActiveObject(text);
        text.enterEditing();
        text.hiddenTextarea?.focus();
        editor.canvas.off('mouse:move');
        editor.canvas.isDrawingMode = false;
        handleActiveTool(TOOL_INDEX.SELECT);
      });
    }
  };

  const dragHistory = (e: any) => {
    e.dataTransfer.setData('id', e.target.id);
  };

  useEffect(() => {
    setTimeout(() => {
      if (document.getElementById(`toolbar-${props.idxSlide}`)) {
        dragToolbar(document.getElementById(`toolbar-${props.idxSlide}`));
      }
    }, 2000);

    function dragToolbar(elmnt: any) {
      if (!elmnt) {
        return;
      }
      var pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0;
      elmnt.onmousedown = dragMouseDown;

      function dragMouseDown(e: any) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
      }

      function elementDrag(e: any) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        if (elmnt.offsetTop < 50) {
          setToolbarStyle({
            width: TOOLBAR_STYLE.HEIGHT,
            height: TOOLBAR_STYLE.WIDTH,
            direction: TOOLBAR_STYLE.ROW,
          });
        } else {
          setToolbarStyle({
            width: TOOLBAR_STYLE.WIDTH,
            height: TOOLBAR_STYLE.HEIGHT,
            direction: TOOLBAR_STYLE.COLUMN,
          });
        }
        // set the element's new position:
        elmnt.style.top = elmnt.offsetTop - pos2 + 'px';
        elmnt.style.left = elmnt.offsetLeft - pos1 + 'px';
      }

      function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
      }
    }

    if (props.openDialogDraw) {
      setTimeout(() => {
        if (document.getElementById('simplebarScroll')) {
          registerHandleScroll();
        }
      }, 1000);

      let registerHandleScroll = () => {
        const simpleBar = simpleBarRef.current?.getScrollElement();

        if (simpleBar) {
          const handleScroll = (event: Event) => {
            topScrollRef.current = simpleBar.scrollTop;
          };

          simpleBar.addEventListener('scroll', handleScroll);
        }
      };
    }
    // eslint-disable-next-line
  }, [props.openDialogDraw]);

  const setPositionToolbarSpeechToText = (top: number, left: number) => {
    const toolbar = document.getElementById('toolbarSpeechToText');

    if (showToolbarSpeechToText && toolbar) {
      if (top !== undefined && left !== undefined) {
        toolbar.style.top = `${top - topScrollRef.current}px`;
        toolbar.style.left = `${left + 20}px`;
      }
    }
  };

  useEffect(() => {
    if (!editor) {
      return;
    }
    const active: any = editor?.canvas.getActiveObject();

    // if not forcus add text
    if (
      active === null ||
      active === undefined ||
      active.isEditing === undefined ||
      active.text === undefined
    ) {
      setShowToolbarSpeechToText(false);
      setActiveObjectAddText(undefined);
    } else {
      setActiveObjectAddText(active);
      // Diabled temp
      setShowToolbarSpeechToText(false);
    }

    // eslint-disable-next-line
  }, [editor?.canvas.getActiveObject()]);

  useEffect(() => {
    if (activeObjectAddText) {
      setPositionToolbarSpeechToText(
        activeObjectAddText.top,
        activeObjectAddText.left
      );
    }

    // eslint-disable-next-line
  }, [activeObjectAddText?.top, activeObjectAddText?.left]);

  useEffect(() => {
    if (!editor) {
      return;
    }
    const handleObjectMoving = (e: any) => {
      const active = e.target;

      if (
        active &&
        active.text !== undefined &&
        active.isEditing !== undefined
      ) {
        setPositionToolbarSpeechToText(active.top, active.left);
      }
    };

    if (showToolbarSpeechToText) {
      if (editor?.canvas) {
        editor.canvas.on('object:moving', handleObjectMoving);
      }
    } else {
      if (editor?.canvas) {
        editor.canvas.off('object:moving', handleObjectMoving);
      }
    }
    // eslint-disable-next-line
  }, [showToolbarSpeechToText]);

  useEffect(() => {
    if (!editor || !fabric) {
      return;
    }
    
    const handleDroppedFiles = (files: File[], pointer: {x: number, y: number}) => {
      if (!editor) return;
      
      files.forEach((file) => {
        const validTypes = ['image/jpg', 'image/jpeg', 'image/png', 'image/svg+xml'];
        if (!validTypes.includes(file.type)) {
          console.log('Invalid file type:', file.type);
          return;
        }
        
        const reader = new FileReader();
        reader.onload = (e) => {
          const imageDataUrl = e.target?.result as string;
          
          fabric.Image.fromURL(imageDataUrl, (img) => {
            const maxWidth = 300;
            const maxHeight = 300;
            
            if (img.width! > maxWidth || img.height! > maxHeight) {
              const scale = Math.min(maxWidth / img.width!, maxHeight / img.height!);
              img.scale(scale);
            }

            img.set({
              left: pointer.x - (img.getScaledWidth() / 2),
              top: pointer.y - (img.getScaledHeight() / 2),
              selectable: true,
            });
            
            editor.canvas.add(img);
            editor.canvas.setActiveObject(img);
            editor.canvas.renderAll();
          }, { crossOrigin: "anonymous" });
        };
        
        reader.readAsDataURL(file);
      });
      
      // Switch to select mode after dropping
      onSelectItem();
    };

    const handleDroppedElement = (dragData: string, pointer: {x: number, y: number}) => {
      if (!editor) return;
      
      if (dragData.startsWith('image-')) {
        const imageElement = document.getElementById(dragData) as HTMLImageElement;
        if (imageElement) {
          fabric.Image.fromURL(imageElement.src, (img) => {
            const maxWidth = 200;
            const maxHeight = 200;
            
            if (img.width! > maxWidth || img.height! > maxHeight) {
              const scale = Math.min(maxWidth / img.width!, maxHeight / img.height!);
              img.scale(scale);
            }
            
            img.set({
              left: pointer.x - (img.getScaledWidth() / 2),
              top: pointer.y - (img.getScaledHeight() / 2),
              selectable: true,
            });
            
            editor.canvas.add(img);
            editor.canvas.setActiveObject(img);
            editor.canvas.renderAll();
          }, { crossOrigin: "anonymous" });
        }
      }
      
      if (dragData.startsWith('history-')) {
        const historyTime = document.getElementById(`${dragData}-time`);
        const historyContent = document.getElementsByClassName(`${dragData}-content`);
    
        let time = historyTime?.innerText || '';
        Array.from(historyContent).forEach((content: any, index: number) => {
          time += `\n> ${content.innerText}`;
        });
        
        const text = new fabric.IText(time, {
          fill: color,
          fontSize: 16,
          top: pointer.y,
          left: pointer.x,
          selectable: true,
          width: 200,
        });
        
        editor.canvas.add(text);
        editor.canvas.setActiveObject(text);
        text.enterEditing();
        text.hiddenTextarea?.focus();
      }
      
      onSelectItem();
    };
    
    const handleCanvasDragOver = (e: DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
      e.dataTransfer!.dropEffect = 'copy';
      
      // Thêm visual feedback (optional)
      const canvasContainer = e.currentTarget as HTMLElement;
      canvasContainer.style.backgroundColor = 'rgba(59, 130, 246, 0.1)';
    };

    const handleCanvasDragEnter = (e: DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
    };
    
    const handleCanvasDragLeave = (e: DragEvent) => {
      e.preventDefault();
      e.stopPropagation();

      const canvasContainer = e.currentTarget as HTMLElement;
      canvasContainer.style.backgroundColor = '';
    };

    const handleCanvasDrop = (e: DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (!editor) return;

      const canvasContainer = e.currentTarget as HTMLElement;
      canvasContainer.style.backgroundColor = '';

      const canvasElement = editor.canvas.getElement();
      const rect = canvasElement.getBoundingClientRect();
      const dropX = e.clientX - rect.left;
      const dropY = e.clientY - rect.top;

      const pointer = editor.canvas.restorePointerVpt({x: dropX, y: dropY});

      const files = Array.from(e.dataTransfer?.files || []);
      if (files.length > 0) {
        handleDroppedFiles(files, pointer);
        return;
      }

      const dragData = e.dataTransfer?.getData('id');
      if (dragData) {
        handleDroppedElement(dragData, pointer);
      }
    };

    const canvasElement = editor.canvas.getElement();
    const canvasContainer = canvasElement.parentElement;
  
    if (canvasContainer) {
      canvasContainer.addEventListener('dragover', handleCanvasDragOver);
      canvasContainer.addEventListener('drop', handleCanvasDrop);
      canvasContainer.addEventListener('dragenter', handleCanvasDragEnter);
      canvasContainer.addEventListener('dragleave', handleCanvasDragLeave);
    }
  

    return () => {
      if (canvasContainer) {
        canvasContainer.removeEventListener('dragover', handleCanvasDragOver);
        canvasContainer.removeEventListener('drop', handleCanvasDrop);
        canvasContainer.removeEventListener('dragenter', handleCanvasDragEnter);
        canvasContainer.removeEventListener('dragleave', handleCanvasDragLeave);
      }
    };
  }, [editor, color, onSelectItem]);

  useEffect(() => {
    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.key === 'z' && !e.shiftKey) {
        e.preventDefault();
        onUndo();
        return;
      }

      if (e.ctrlKey && e.shiftKey && e.key === 'Z') {
        e.preventDefault();
        onRedo();
        return;
      }

      if (e.key === 'Delete' || e.key === 'Backspace') {
        onRemoveItem();
      }
    };
  
    document.addEventListener('keyup', handleKeyUp);
    return () => document.removeEventListener('keyup', handleKeyUp);
  }, [onUndo, onRedo, onRemoveItem]);

  const canUndo = historyState.step > 0;
  const canRedo = historyState.step < historyState.history.length - 1;

  return (
    <>
      <Box
        id='scroll-dialog-title'
        sx={{ p: '8px 16px', borderBottom: '1px solid #F3F3F3' }}
        width={'100%'}
      >
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Stack
            direction={'row'}
            spacing={'16px'}
            color={'primary.dark'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Typography lineHeight={'16px'}>
              { props.patient?.patientno }
            </Typography>
            <Typography lineHeight={'16px'}>
              { props.patient?.fullname }
            </Typography>
            <Typography lineHeight={'16px'}>
              { props.patient?.age }
            </Typography>
            <Typography lineHeight={'16px'}>
              { kartedate }
            </Typography>
            <Box
              component={'img'}
              src='/images/icons/ic-edit.svg'
              alt='icon edit'
              width={'16px'}
              height={'16px'}
              sx={{
                cursor: 'pointer',
              }}
            ></Box>
          </Stack>
          <Stack
            direction={'row'}
            spacing={'10px'}
            color={'primary.dark'}
            alignItems={'center'}
          >
            <Box
              component={'img'}
              src='/images/icons/draw/ic-picture.svg'
              alt='icon picture'
              width={'24px'}
              height={'24px'}
              sx={{
                cursor: 'pointer',
              }}
              onClick={handleOpenCamera}
            ></Box>
            <Button
              component='label'
              role={undefined}
              tabIndex={-1}
              sx={{
                minWidth: '24px',
                p: 0,
                '& .MuiButton-startIcon': { mx: 0 },
              }}
              startIcon={
                <Box
                  component={'img'}
                  src='/images/icons/draw/ic-folder.svg'
                  alt='icon folder'
                  width={'24px'}
                  height={'24px'}
                  sx={{
                    cursor: 'pointer',
                  }}
                ></Box>
              }
            >
              <VisuallyHiddenInput type='file' accept='image/jpeg, image/png, image/svg+xml' onChange={handleChooseImage} />
            </Button>
            <BtnGradient handleButtonClick={handleBtnTranscription} text='音声入力' />
            <BtnGradient handleButtonClick={handleBtnSave} text='保存' />
            {/* <BtnOutlineGradient
              handleButtonClick={handleBtnReturn}
              text='戻る'
            /> */}
            <Box
              component={'img'}
              src='/images/icons/ic-close.svg'
              alt='icon close'
              onClick={handleBtnReturn}
              width={'24px'}
              height={'24px'}
              sx={{
                cursor: 'pointer',
              }}
            ></Box>
          </Stack>
        </Stack>
      </Box>
      <Box sx={{ pl: '16px', pr: '0px', pb: '0px', position: 'relative' }}>
        <Box
          position={'absolute'}
          width={TOOLBAR_STYLE.WIDTH}
          height={TOOLBAR_STYLE.HEIGHT}
        >
          <Stack
            width={toolbarStyle.width}
            height={toolbarStyle.height}
            direction={toolbarStyle.direction}
            justifyContent={'space-between'}
            alignItems={'center'}
            p={'5px'}
            position={'absolute'}
            top={'60px'}
            left={'0'}
            zIndex={10}
            id={`toolbar-${props.idxSlide}`}
            sx={{
              backgroundColor: 'primary.light',
              cursor: 'move',
              boxShadow: '0px 6px 12px 0px #0000001A;',
              '& .MuiBox-root.tools, & .MuiStack-root.tools': {
                cursor: 'pointer',
                borderRadius: '4px',
              },
              '& .MuiBox-root.tools:hover, & .MuiStack-root.tools:hover': {
                backgroundColor: '#CCD1D9',
              },
              '& .MuiBox-root.active, & .MuiStack-root.active': {
                backgroundColor: '#CCD1D9',
              },
            }}
          >
            <Box
              component={'img'}
              src='/images/icons/draw/ic-more.svg'
              alt='ic-more'
              width={'24px'}
              sx={{ cursor: 'move' }}
              id='toolbar-move'
            />
            <Stack
              width={'24px'}
              height={'24px'}
              justifyContent={'center'}
              alignItems={'center'}
              className={`tools ${
                activeColor[COLOR_INDEX.BLACK] ? 'active' : ''
              }`}
              onClick={() => handleChangeColor('#434154', COLOR_INDEX.BLACK)}
            >
              <Box
                component={'img'}
                src='/images/icons/draw/ic-color-black.svg'
                alt='ic-color-black'
                width={'16px'}
              />
            </Stack>
            <Stack
              width={'24px'}
              height={'24px'}
              justifyContent={'center'}
              alignItems={'center'}
              className={`tools ${
                activeColor[COLOR_INDEX.RED] ? 'active' : ''
              }`}
              onClick={() => handleChangeColor('#ED5565', COLOR_INDEX.RED)}
            >
              <Box
                component={'img'}
                src='/images/icons/draw/ic-color-red.svg'
                alt='ic-color-red'
                width={'16px'}
              />
            </Stack>
            <Stack
              width={'24px'}
              height={'24px'}
              justifyContent={'center'}
              alignItems={'center'}
              className={`tools ${
                activeColor[COLOR_INDEX.BLUE] ? 'active' : ''
              }`}
              onClick={() => handleChangeColor('#3061C2', COLOR_INDEX.BLUE)}
            >
              <Box
                component={'img'}
                src='/images/icons/draw/ic-color-blue.svg'
                alt='ic-color-blue'
                width={'16px'}
              />
            </Stack>
            <Box
              component={'img'}
              src='/images/icons/ic-edit.svg'
              alt='ic-edit'
              width={'24px'}
              className={`tools ${activeTool[TOOL_INDEX.EDIT] ? 'active' : ''}`}
              onClick={onToggleDraw}
            />
            <Box
              component={'img'}
              src='/images/icons/draw/ic-text-tt.svg'
              alt='ic-text-tt'
              width={'24px'}
              className={`tools ${activeTool[TOOL_INDEX.TEXT] ? 'active' : ''}`}
              onClick={onAddText}
            />
            <Box
              component={'img'}
              src='/images/icons/draw/ic-erase.svg'
              alt='ic-erase'
              width={'24px'}
              className={`tools ${
                activeTool[TOOL_INDEX.ERASE] ? 'active' : ''
              }`}
              onClick={onEraser}
            />
            <Box
              component={'img'}
              src='/images/icons/draw/ic-select.svg'
              alt='ic-select'
              width={'24px'}
              className={`tools ${
                activeTool[TOOL_INDEX.SELECT] ? 'active' : ''
              }`}
              onClick={onSelectItem}
            />
            <Box
              component={'img'}
              src='/images/icons/draw/ic-undo.svg'
              alt='ic-undo'
              width={'24px'}
              className='tools roll-left'
              onClick={onUndo}
              sx={{ 
                opacity: canUndo ? 1 : 0.5,
                cursor: canUndo ? 'pointer' : 'not-allowed'
              }}
            />
            <Box
              component={'img'}
              src='/images/icons/draw/ic-redo.svg'
              alt='ic-redo'
              width={'24px'}
              className='tools roll-right'
              onClick={onRedo}
              sx={{ 
                opacity: canRedo ? 1 : 0.5,
                cursor: canRedo ? 'pointer' : 'not-allowed'
              }}
            />
            <Box
              component={'img'}
              src='/images/icons/ic-trash.svg'
              alt='ic-trash'
              width={'24px'}
              className='tools'
              onClick={onRemoveItem}
            />
            <Box
              component={'img'}
              src='/images/icons/draw/ic-zoom-in.svg'
              alt='ic-zoom-in'
              width={'24px'}
              className='tools'
              onClick={onZoomIn}
            />
            <Box
              component={'img'}
              src='/images/icons/draw/ic-zoom-out.svg'
              alt='ic-zoom-out'
              width={'24px'}
              className='tools'
              onClick={onZoomOut}
            />
            {/* <Box sx={{ width: '24px' }}>
                <SpeechToText editor={editor} />
              </Box> */}
          </Stack>

          {showToolbarSpeechToText && (
            <Box
              display={'flex'}
              width={'24px'}
              height={'24px'}
              justifyContent={'center'}
              alignItems={'center'}
              position={'absolute'}
              zIndex={10}
              id='toolbarSpeechToText'
              sx={{
                backgroundColor: 'primary.light',
                border: '1px solid #23B7E5',
                borderRadius: '50%',
                '& .MuiBox-root.tools, & .MuiStack-root.tools': {
                  cursor: 'pointer',
                  borderRadius: '4px',
                },
                '& .MuiBox-root.tools:hover, & .MuiStack-root.tools:hover': {
                  backgroundColor: '#CCD1D9',
                },
                '& .MuiBox-root.active, & .MuiStack-root.active': {
                  backgroundColor: '#CCD1D9',
                },
              }}
            >
              {/* <SpeechToText editor={editor} /> */}
            </Box>
          )}
        </Box>

        <Stack
          height={'100%'}
          pl={'56px'}
          direction={'row'}
          justifyContent={'space-between'}
          sx={{
            '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before':
              { backgroundColor: '#CCD1D9' },
          }}
        >
          <Box width={'calc(100% - 360px);'}>
            <SimpleBar
              ref={simpleBarRef}
              id='simplebarScroll'
              style={{ height: '100%', borderWidth: '18px' }}
            >
              <div
                id='canvas_cont'
                onDragOver={(event: any) => allowDrop(event)}
                onDrop={(event) => dropElement(event)}
              >
                <FabricJSCanvas className='sample-canvas' onReady={onReady} />
              </div>
            </SimpleBar>
          </Box>
          <Stack
            direction={'row'}
            height={'100%'}
            sx={{ '& .simplebar-content': { height: '100%' } }}
          >
            {showRightBar && tabRightActive === TAB_RIGHT.INFORMATION && (
              <SimpleBar style={{ height: '100%', borderWidth: '18px' }}>
                <Stack
                  width={'302px'}
                  p={'24px'}
                  borderLeft={'1px solid #F3F3F3'}
                  sx={{ backgroundColor: '#FAFDFF' }}
                >
                  <Stack direction={'row'} justifyContent={'space-between'}>
                    <Typography fontSize={'14px'} fontWeight={700}>
                      患者情報
                    </Typography>
                    <Box
                      component={'img'}
                      src='/images/icons/draw/ic-arrow-menuright.svg'
                      alt='ic-note'
                      width={'24px'}
                      sx={{ cursor: 'pointer' }}
                      onClick={handleHideRightBar}
                    />
                  </Stack>
                  <PatientInfo patient={props.patient} />
                </Stack>
              </SimpleBar>
            )}
            {showRightBar && tabRightActive === TAB_RIGHT.AVATAR && (
              <SimpleBar style={{ height: '100%', borderWidth: '18px' }}>
                <Stack
                  width={'302px'}
                  p={'24px'}
                  borderLeft={'1px solid #F3F3F3'}
                  sx={{ backgroundColor: '#FAFDFF' }}
                >
                  <Stack direction={'row'} justifyContent={'space-between'}>
                    <Typography fontSize={'14px'} fontWeight={700}>
                      画像
                    </Typography>
                    <Box
                      component={'img'}
                      src='/images/icons/draw/ic-arrow-menuright.svg'
                      alt='ic-note'
                      width={'24px'}
                      sx={{ cursor: 'pointer' }}
                      onClick={handleHideRightBar}
                    />
                  </Stack>
                  <Grid container spacing={'20px'} mt={'10px'}>
                    {imageList.map((image: any, index: number) => {
                      return (
                        <Grid key={index} item xs={6}>
                          <Stack alignItems={'center'}>
                            <Stack direction={'row'} spacing={'4px'}>
                              <Box
                                component={'img'}
                                src='/images/icons/ic-edit.svg'
                                alt='edit'
                                sx={{ cursor: 'pointer' }}
                              />
                              <Box
                                component={'img'}
                                src='/images/icons/ic-trash.svg'
                                alt='trash'
                                sx={{ cursor: 'pointer' }}
                              />
                            </Stack>
                            <Box
                              component={'img'}
                              src={image.preview}
                              alt='ic-note'
                              width={'80px'}
                              height={'auto'}
                              id={`image-${index}`}
                              onDragStart={(event) => dragElement(event)}
                            />
                            <Stack>
                              <FormControlLabel
                                control={<Checkbox />}
                                label={image.name}
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: '18px' },
                                  '& .MuiTypography-root': {
                                    fontSize: '14px',
                                    wordBreak: 'break-word',
                                  },
                                }}
                              />
                            </Stack>
                          </Stack>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Stack>
              </SimpleBar>
            )}
            {showRightBar && tabRightActive === TAB_RIGHT.HISTORY && (
              <SimpleBar style={{ height: '100%', borderWidth: '18px' }}>
                <Stack
                  height={'100%'}
                  width={'302px'}
                  p={'24px'}
                  borderLeft={'1px solid #F3F3F3'}
                  sx={{ backgroundColor: '#FAFDFF' }}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={'space-between'}
                    mb={'24px'}
                  >
                    <Typography fontSize={'14px'} fontWeight={700}>
                      施術履歴
                    </Typography>
                    <Box
                      component={'img'}
                      src='/images/icons/draw/ic-arrow-menuright.svg'
                      alt='ic-note'
                      width={'24px'}
                      sx={{ cursor: 'pointer' }}
                      onClick={handleHideRightBar}
                    />
                  </Stack>
                  {/* <PatientInfo patient={props.patient}/> */}
                  {Object.entries(historyList).map(
                    (his: any, index: number) => {
                      return (
                        <Stack key={index}>
                          <Stack
                            direction={'row'}
                            p={'8px 0'}
                            spacing={'20px'}
                            id={`history-${index}`}
                            sx={{ cursor: 'pointer' }}
                            onDragStart={(event) => dragHistory(event)}
                            draggable='true'
                          >
                            <Typography
                              width={'65px'}
                              id={`history-${index}-time`}
                              lineHeight={'24px'}
                            >
                              {his[0]}
                            </Typography>
                            <Typography
                              fontSize={'14px'}
                              fontWeight={500}
                              color={'#484848'}
                            >
                              {his[1].map((h: any, idx: number) => {
                                return (
                                  <Typography
                                    display={'block'}
                                    component='span'
                                    key={idx}
                                    className={`history-${index}-content`}
                                  >
                                    {h.category}
                                  </Typography>
                                );
                              })}
                            </Typography>
                          </Stack>
                          {!(
                            index > 0 &&
                            historyList[index + 1] &&
                            historyList[index + 1].quotedate === his.quotedate
                          ) && <Divider sx={{ borderColor: '#F3F3F3' }} />}
                        </Stack>
                      );
                    }
                  )}
                </Stack>
              </SimpleBar>
            )}
            <Stack
              width={'48px'}
              borderLeft={'1px solid #F3F3F3'}
              alignItems={'center'}
              sx={{
                '& .MuiStack-root.item.active': {
                  backgroundColor: '#E8F8FF',
                },
                '& .MuiStack-root.item:hover': {
                  backgroundColor: '#E8F8FF',
                },
              }}
            >
              <Stack
                height={'44px'}
                width={'100%'}
                alignItems={'center'}
                justifyContent={'center'}
                sx={{ cursor: 'pointer' }}
                className={`item ${
                  tabRightActive === TAB_RIGHT.INFORMATION ? 'active' : ''
                }`}
                onClick={handleInformationClick}
              >
                <Box
                  component={'img'}
                  src={`/images/icons/draw/ic-note${
                    tabRightActive === TAB_RIGHT.INFORMATION ? '-active' : ''
                  }.svg`}
                  alt='ic-note'
                  width={'24px'}
                />
              </Stack>
              <Stack
                height={'44px'}
                width={'100%'}
                alignItems={'center'}
                justifyContent={'center'}
                sx={{ cursor: 'pointer' }}
                className={`item ${
                  tabRightActive === TAB_RIGHT.AVATAR ? 'active' : ''
                }`}
                onClick={handleAvatarTabClick}
              >
                <Box
                  component={'img'}
                  src={`/images/icons/draw/ic-avatar-draw${
                    tabRightActive === TAB_RIGHT.AVATAR ? '-active' : ''
                  }.svg`}
                  alt='ic-avatar-draw'
                  width={'24px'}
                />
              </Stack>
              <Stack
                height={'44px'}
                width={'100%'}
                alignItems={'center'}
                justifyContent={'center'}
                sx={{ cursor: 'pointer' }}
                className={`item ${
                  tabRightActive === TAB_RIGHT.HISTORY ? 'active' : ''
                }`}
                onClick={handleHistoryTabClick}
              >
                <Box
                  component={'img'}
                  src={`/images/icons/ic-by-treatment${
                    tabRightActive === TAB_RIGHT.HISTORY ? '-active' : ''
                  }.svg`}
                  alt='ic-avatar-draw'
                  width={'24px'}
                />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Box>
      <DialogCamera
        openDialogCamera={openDialogCamera}
        handleCloseDialogCamera={handleCloseDialogCamera}
        handleCaptureImage={handleCaptureImage}
      />
      <ConfirmDialog
        open={openConfirmCancel}
        onCancel={handleCloseConfirm}
        onConfirm={handleConfirmCancel}
        title='確認'
        description='このまま戻ると、写真や入力内容が消えてしまいます。よろしいですか？'
        confirmText='はい、戻る'
        cancelText='いいえ、続ける'
        confirmColor='#DA4453'
      />
    </>
  );
};

export default DialogDrawSlide;
